export default {
  MuiDialogContent: {
    root: {
      padding: 0,
      '&:first-child': {
        paddingTop: 0,
      },
    },
  },
};
